// extracted by mini-css-extract-plugin
export default {"chatPortalContainer":"PortalContainerUtils-module__chatPortalContainer--Otmle","menuPortalContainer":"PortalContainerUtils-module__menuPortalContainer--D7AeL"};